(function () {
    function initAboutCounters() {
        var counters = Array.prototype.slice.call(
            document.querySelectorAll('[data-about-counter]')
        );

        if (!counters.length || typeof window.gsap === 'undefined') return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        var preparedCounters = counters.map(function (counter, index) {
            var originalText = counter.textContent.trim();
            var match = originalText.match(/^([+-]?[0-9][0-9\s.,]*)(.*)$/);

            if (!match) return null;

            var numericText = match[1].replace(/\s+/g, '').replace(',', '.');
            var finalValue = Number(numericText);

            if (!Number.isFinite(finalValue)) return null;

            var decimals = numericText.indexOf('.') === -1
                ? 0
                : numericText.split('.')[1].length;
            var startRatio = 0.84 + Math.min(index, 3) * 0.01;
            var startValue = finalValue * startRatio;

            if (decimals === 0) {
                startValue = Math.floor(startValue);
            }

            return {
                element: counter,
                state: { value: startValue },
                finalValue: finalValue,
                decimals: decimals,
                suffix: match[2]
            };
        }).filter(Boolean);

        if (!preparedCounters.length) return;

        function renderCounter(counter) {
            counter.element.textContent =
                counter.state.value.toFixed(counter.decimals) + counter.suffix;
        }

        preparedCounters.forEach(renderCounter);

        function playCounters() {
            preparedCounters.forEach(function (counter, index) {
                window.gsap.to(counter.state, {
                    value: counter.finalValue,
                    duration: 1.8 + index * 0.1,
                    delay: index * 0.08,
                    ease: 'power2.out',
                    onUpdate: function () {
                        renderCounter(counter);
                    },
                    onComplete: function () {
                        counter.element.textContent =
                            counter.finalValue.toFixed(counter.decimals) + counter.suffix;
                    }
                });
            });
        }

        var stats = preparedCounters[0].element.closest(
            '.about__stats, .about-us__statistics-list'
        );

        if (!stats || !('IntersectionObserver' in window)) {
            playCounters();
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;

                playCounters();
                observer.unobserve(entry.target);
            });
        }, {
            threshold: 0.35,
            rootMargin: '0px 0px -8% 0px'
        });

        observer.observe(stats);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAboutCounters);
    } else {
        initAboutCounters();
    }
})();
